import type { SeparatorProps } from './types'

import * as S from './styles'

export const SeparatorWithLine = ({ ...rest }: SeparatorProps) => {
  return <S.Separator {...rest} />
}
